(() => {
  const template = document.getElementById('volt-breadcrumbs-template');
  const root = document.getElementById('volt-storefront');
  if (!(template instanceof HTMLTemplateElement) || !root) return;
  const phoneTemplate = document.getElementById('volt-contact-phone-template');
  const phoneCards = new WeakMap();

  const mountPhoneCard = (page) => {
    if (!(phoneTemplate instanceof HTMLTemplateElement)) return;
    const panel = page.querySelector('.vc-contact-call');
    const sourcePhone = panel?.querySelector(':scope > .vc-contact-dial');
    const sourceStatus = panel?.querySelector(':scope > .vc-contact-status');
    const sourceHours = panel?.querySelector(':scope > .vc-contact-hours-section');
    const sourceHolidays = panel?.querySelector(':scope > .vc-contact-holiday-dialog .vc-contact-holiday-list');
    if (!sourcePhone || !sourceStatus || !sourceHours || !sourceHolidays) return;
    let state = phoneCards.get(panel);
    if (!state) {
      const card = phoneTemplate.content.firstElementChild.cloneNode(true);
      panel.append(card);
      state = { card };
      phoneCards.set(panel, state);
    }
    const { card } = state;
    const phoneKey = sourcePhone.outerHTML;
    if (state.phoneKey !== phoneKey) {
      const phone = sourcePhone.cloneNode(true);
      phone.className = 'volt-contact-phone';
      card.querySelector('[data-phone-slot]').replaceChildren(phone);
      state.phoneKey = phoneKey;
    }
    const detail = sourceStatus.querySelector('p')?.textContent.trim() || '';
    const open = sourceStatus.dataset.open === 'true';
    const statusKey = `${open}:${detail}`;
    if (state.statusKey !== statusKey) {
      const availability = card.querySelector('[data-availability-slot]');
      const openingTime = !open && detail.match(/(\d{1,2}\s*(?:AM|PM))$/);
      if (openingTime) {
        const time = document.createElement('strong');
        time.textContent = `${openingTime[1]} ${phoneTemplate.dataset.timezone}`;
        availability.replaceChildren(document.createTextNode(detail.slice(0, openingTime.index)), time);
      } else {
        availability.textContent = detail;
      }
      card.dataset.open = String(open);
      state.statusKey = statusKey;
    }
    const hoursKey = sourceHours.innerHTML;
    if (state.hoursKey !== hoursKey) {
      const hours = sourceHours.cloneNode(true);
      hours.className = 'volt-contact-weekly-hours';
      hours.querySelector('dl').className = 'volt-contact-hours-list';
      hours.querySelector('p').className = 'volt-contact-zone';
      hours.querySelectorAll('dt').forEach(label => {
        if (!label.textContent.trim().endsWith(':')) label.append(document.createTextNode(':'));
      });
      card.querySelector('[data-weekly-hours-slot]').replaceChildren(hours);
      state.hoursKey = hoursKey;
    }
    const holidaysKey = sourceHolidays.innerHTML;
    if (state.holidaysKey !== holidaysKey) {
      const holidays = sourceHolidays.cloneNode(true);
      holidays.className = 'volt-contact-holiday-list';
      card.querySelector('[data-holidays-slot]').replaceChildren(holidays);
      state.holidaysKey = holidaysKey;
    }
    panel.classList.add('volt-contact-card-ready');
  };

  const mount = () => {
    const target = root.querySelector(template.dataset.target);
    if (!target) return;
    if (!target.querySelector(':scope > .volt-breadcrumbs')) {
      target.prepend(template.content.cloneNode(true));
      target.classList.add('volt-has-breadcrumb');
      target.closest('main')?.classList.add('volt-has-breadcrumb');
    }
    mountPhoneCard(target);
  };

  mount();
  if (root instanceof Node) new MutationObserver(mount).observe(root, { childList: true, subtree: true });
})();
